export default class BookingSummary {
    constructor(dom) {
        this.dom = dom;
        this.locationList = [];
        let locationData = dom.querySelector('input[name=location-data]');
        
        if(locationData.value){
            this.locationList = JSON.parse(locationData.value);
        }
    }
    init(){
        // console.log('init booking summary!');
        let resultElem =  document.querySelector("#custom-price-calculate .result");
        if(resultElem){
            let observer = new MutationObserver(mutations => {
                this.update('totalPrice', '');
            });
            observer.observe(resultElem, {childList: true, subtree: true});
        }
        
        let addtoCartBtn = this.dom.querySelector('.addtocart button');
        if(addtoCartBtn){
            addtoCartBtn.addEventListener('click', ()=>{
                console.log(addtoCartBtn.getAttribute('data-target'));
                // alert(document.querySelector(".single_add_to_cart_button")+' / '+ addtoCartBtn.getAttribute('data-target'));
                if(addtoCartBtn.getAttribute('data-target')==""){
                    if(document.querySelector(".single_add_to_cart_button")){
                        document.querySelector(".single_add_to_cart_button").click();
                    }
                }
            });
        }
        this.update('totalPrice', '');
        
        
    }
    update(type, val){
        switch(type){
            case 'totalPrice':
                if(document.querySelector("#custom-price-calculate .result")){
                    this.dom.querySelector('.product-total #summary-total').innerHTML = document.querySelector("#custom-price-calculate .result").textContent;
                }else if(document.querySelector(".entry-summary .woocommerce-Price-amount.amount")){
                    this.dom.querySelector('.product-total #summary-total').innerHTML = document.querySelector(".entry-summary .woocommerce-Price-amount.amount").textContent;
                }
                break;
            case 'location':
                this.locationList.forEach(element => {
                    if(element.unitID==val){
                        console.log(element.name);
                        this.dom.querySelector('#summary-loc').innerHTML = element.name;
                    }
                });
                break;
            case 'leatherChoice':
                let tmpLbl = '';
                let summaryLeatherWrapper = this.dom.querySelector('#summary-leather').closest('.cft--item'); 
                
                if(val==4){ // Select Leather when arrive studio
                    tmpLbl = document.querySelector('[js-sl-radio] label[for=radio-1]>h4');
                    if(tmpLbl.textContent){
                        tmpLbl = tmpLbl.textContent;
                    }
                    summaryLeatherWrapper.querySelector('.edit').setAttribute('data-stepnext',2);
                    document.querySelector('.addtocart button.btn.btn-mega').setAttribute('data-target','');
                }else if(val==3 ){ // choosen leather now
                    tmpLbl = document.querySelector('[js-sl-radio] label[for=radio-2]>h4');
                    if(tmpLbl.textContent){
                        tmpLbl = tmpLbl.textContent;
                    }
                    summaryLeatherWrapper.querySelector('.edit').setAttribute('data-stepnext',3);
                    document.querySelector('.addtocart button.btn.btn-mega').setAttribute('data-target','generatePreview');
                }
                this.dom.querySelector('#summary-leather').innerHTML = tmpLbl;
                
                break;
            case 'booking':
                this.dom.querySelector('#summary-date').innerHTML = val; // 12 July 2023 11:30 A.M.
                break;
        }
    }
}